import React, { useState, useEffect, useMemo } from 'react'
import { Modal } from 'react-bootstrap';
import { ChevronDown } from "lucide-react"
import Select, { components } from 'react-select';
import { GET_ALL_USER } from '../../utils/Apifunction';
import AutomationStatusDropdown from './AutomationStatusSelectDropdown';
import { Select as MuiSelect, MenuItem, InputLabel, FormControl } from '@mui/material';
import { getLocalStorageItem, removeLocalStorageItem } from '../../utils/Localstorage/localStorageUtils';
import services from '../../services';
import { toast } from 'react-toastify';
const IncomingMail = ({
    onHide,
    show,
    getAllAutomation,
    gmailUsers,
    editData,
    editId,
    setStep,
    setAutomations,
    setEditId,
    automation
}) => {
    const [email, setEmail] = useState("")
    const [accessMethod, setAccessMethod] = useState("")
    const [board, setBoard] = useState("")
    const [list, setList] = useState("")
    const [skipInbox, setSkipInbox] = useState(false)
    const [skipReplies, setSkipReplies] = useState(true)
    const [runOnExisting, setRunOnExisting] = useState(false)
    const [advancedMode, setAdvancedMode] = useState(false)
    const [conditions, setConditions] = useState([{ type: "when", value: "" }])
    const [selectedMailUser, setSelectedMailUser] = useState();
    const [syncGmail, setSyncGmail] = useState([]);
    const [boardList, setBoardList] = useState([]);
    const [columnList, setColumnList] = useState([]);
    const [boardName, setBoardName] = useState([]);
    const [days, setDays] = useState(1);
    const [boardError, setBoardError] = useState('');
    const [selectedType, setSelectedType] = useState("new");
    const [duplicateMsg, setDuplicateMsg] = useState('');
    const [userData, setUserData] = useState([]);
    const [customFieldOptionsByRow, setCustomFieldOptionsByRow] = useState({});
    const [selectedCustomFieldByRow, setSelectedCustomFieldByRow] = useState({});
    const [customFieldLoadingByRow, setCustomFieldLoadingByRow] = useState({});
    const [customFieldErrorByRow, setCustomFieldErrorByRow] = useState({});
    const [customPropertyOptions, setCustomPropertyOptions] = useState([]);
    const [actionRows, setActionRows] = useState([{ action: '', order: '', boardId: '', entityId: '' }]);
    const [lables, setLables] = useState([]);
    const [customeFiedId, setCustomeFieldId] = useState(null);
    const [editPropertyId, setEditPropertyId] = useState(null);
    const addCondition = () => {
        setConditions([...conditions, { type: "if", value: "" }])
    }
    const [basicErrors, setBasicErrors] = useState({});

    const options = userData?.map((user) => ({
        value: user.id,
        label: user.name,
        email: user.email,
    }));
    const addAction = () => {
        setConditions([...conditions, { type: "then", value: "" }])
    }
    const conditionOptions = [
        { label: 'the subject', value: 'subject' },
        { label: 'the From email address', value: 'sender' },
        { label: 'the To email address', value: 'recipient' },
    ];
    const GET_ALL_USER_DATA = async () => {
        const response = await GET_ALL_USER();
        response && setUserData(response?.users);
    };

    const getEditData = async (editId) => {
        try {
            const response = await services.automations.GET_BY_ID_AUTOMATIONS(editId);
            if (response && response.data && response.data.data) {
                const automation = response.data.data;

                setConditions([]);

                const emailResponse = await services.email.Get_The_Linked_Email();
                const formattedOptions =
                    emailResponse?.data?.map((item) => ({
                        value: item.id,
                        label: item.email,
                    })) || [];

                setSyncGmail(formattedOptions);

                if (automation?.when?.gmailUserId) {
                    const matchedUser = formattedOptions.find((user) => user.value === automation.when.gmailUserId);
                    if (matchedUser) {
                        setSelectedMailUser(matchedUser);
                    }
                }

                const userConditions = automation.condition.filter((cond) => {

                    // ❌ Hide the existingInboxMails condition from the UI
                    if (cond.operand === 'existingInboxMails') {
                        return false;
                    }

                    return true;
                });


                setConditions(
                    userConditions.map((cond) => ({
                        field: cond.operand,
                        operator: cond.operator,
                        value:
                            cond.operand === 'assignee' && Array.isArray(cond.value)
                                ? cond.value[0]?.entityId || ''
                                : cond.value,
                    })),
                );

                let boardId = null;
                let entityId = null;
                if (automation?.type === 'new') {
                    const createOnListAction = automation.action.find((a) => a.action === 'createOnList');
                    if (createOnListAction) {
                        boardId = createOnListAction.boardId;
                        entityId = createOnListAction.entityId;
                    }
                } else {
                    const boardCondition = automation.condition.find((cond) => cond.operand === 'board');
                    if (boardCondition) {
                        boardId = boardCondition.value;
                    }
                }

                if (boardId) {
                    setBoard(boardId);
                    setList(entityId)
                    getSELECTED_BOARD(boardId);
                }


                   const mainActions = automation.action
                    .filter((a) => a.action !== 'subEmailInbox' && a.action !== 'emailInbox')
                    .map((action, i) => {

                        const mappedAction = {
                            action: action.action,
                            order: action.order,
                            customField: action.customField ?? undefined,
                            customProperty: action.customProperty ?? undefined,
                            user: action.action === 'setCustomProperty' ? action.customProperty ?? '' : undefined
                        };

                        if (action.action === 'setCustomProperty') {
                            mappedAction.customProperty = action.customProperty ?? '';

                            mappedAction.customField = Array.isArray(action.customField) ? action.customField : [];
                            mappedAction.user = action.customProperty ?? '';
                              if (Array.isArray(action.customField) && action.customField.length > 0) {
                                setSelectedCustomFieldByRow(prev => ({
                                    ...prev,
                                    [i]: action.customField.map(cf => ({
                                        id: cf.id,
                                        label: cf.label,
                                        color: cf.color
                                    }))
                                }));


                            }
                            if (action.action === 'setCustomProperty' && action.customProperty) {
                                updateUser(i, action.customProperty);
                            }
                            setEditPropertyId(action.customProperty || '');

                        }
                        if (action.action === 'createOnList') {
                            mappedAction.boardId = action.boardId;
                            mappedAction.entityId = action.entityId;
                        } else if (['assignTo', 'unassign'].includes(action.action)) {
                            mappedAction.user = action.entityId;
                        } else if (action.action === 'assignToRoundRobin') {
                            mappedAction.users =
                                action.entityIds?.map((e) => ({
                                    value: e.entityId,
                                    label: e.name,
                                })) || [];
                        } else if (action.action === 'setSlaAlertTag') {
                            mappedAction.entityId = action.entityValue;
                        } else if (
                            ['sendOverdueAlert', 'sendUpcomingAlert', 'sendNotificationTo'].includes(action.action)
                        ) {
                            mappedAction.entityId = action.entityId;
                            mappedAction.message = action.entityValue;
                        } else if (action.action === 'moveToNextList') {

                            mappedAction.action = 'moveToNext';
                        } else if (action.action === 'moveToPreviousList') {

                            mappedAction.action = 'moveToPreviousList';
                        }


                        else if (action.action === 'setEmailLabel') {
                            const findDeepLabel = (nodes, { parentId = null, labelName }) => {
                                const findNodeById = (list, id) => {
                                    for (const n of list || []) {
                                        if (n.id === id) return n;
                                        if (n.children) {
                                            const found = findNodeById(n.children, id);
                                            if (found) return found;
                                        }
                                    }
                                    return null;
                                };

                                const findDeepInSubtree = (root, name) => {
                                    let best = null;
                                    const dfs = (node, parent) => {
                                        if (node.name === name) {
                                            best = { id: node.id, name: node.name, parentId: parent ? parent.id : null };
                                        }
                                        if (node.children) {
                                            for (const child of node.children) dfs(child, node);
                                        }
                                    };
                                    dfs(root, null);
                                    return best;
                                };

                                if (parentId) {
                                    const ancestor = findNodeById(nodes, parentId);
                                    if (!ancestor) return null;
                                    return findDeepInSubtree(ancestor, labelName);
                                }

                                let deepest = null;
                                const dfsAll = (node, parent) => {
                                    if (node.name === labelName) {
                                        deepest = { id: node.id, name: node.name, parentId: parent ? parent.id : null };
                                    }
                                    if (node.children) {
                                        for (const child of node.children) dfsAll(child, node);
                                    }
                                };
                                for (const n of nodes || []) dfsAll(n, null);
                                return deepest;
                            };

                            const matchedLabel = findDeepLabel(lables, {
                                parentId: action.parentId || null,
                                labelName: action.labelName,
                            });

                            mappedAction.user = matchedLabel || {
                                id: null,
                                name: action.labelName,
                                parentId: action.parentId || null,
                            };
                        }




                        else if (action.action === 'markComplete') {
                            mappedAction.action = 'markComplete';
                        } else if (action.action === 'markIncomplete') {
                            mappedAction.action = 'markIncomplete';
                        }

                        return mappedAction;
                    });

                setActionRows(mainActions);
                if (automation?.type === 'new') {
                    const subEmailInboxAction = automation.action.find((a) => a.action === 'subEmailInbox');
                    const emailInboxAction = automation.action.find((a) => a.action === 'emailInbox');
                    setSkipReplies(subEmailInboxAction ? subEmailInboxAction.isProcessed : false);
                    setSkipInbox(emailInboxAction ? emailInboxAction.hasReply : false);
                }
                if (automation?.condition) {
                    // const subEmailInboxAction = automation.action.find((a) => a.action === 'subEmailInbox');
                    const emailInboxAction = automation.condition.find((a) => a.operand === 'existingInboxMails');
                    if (emailInboxAction?.value) {
                        setDays(emailInboxAction?.value);


                    }
                    if (emailInboxAction?.operand == "existingInboxMails") {
                        setRunOnExisting(true);

                    }
                }

            }
        } catch (e) {
            console.error(e);
        }
    };


    const deleteCustomField = async (id, idx, status,) => {
        try {
            await services?.customfield.DELETE_CUSTOEM_FILED(id);

        } catch (error) {
            console.error('Failed to create custom field or fetch properties', error);
        }
    };
    useEffect(() => {
        if (!editId || !lables?.length) return;
        getEditData(editId);
    }, [editId, lables]);

    const LablesName = async () => {
        const response = await services.labelService.GET_Label_ALL();
        setLables(response?.data?.labels)
    }
    const operatorOptions = [
        { label: 'contains', value: 'contains' },
        { label: 'does not contain', value: 'doesNotContain' },
        { label: 'is', value: 'equals' },
    ];
    const handleCreate = async () => {
        const payload = buildPayload();

        try {
            const response = !editId
                ? await services.automations.CREATE_AUTOMATIONS(payload)
                : await services.automations.UPDATE_AUTOMATIONS(editId, payload);
            if (response) {
                toast.success(editId ? 'Automations Updated Successfully' : 'Automations Added Successfully');
                setStep(1);

                getAllAutomation();
                setAutomations(false)
                removeLocalStorageItem('editGmailUserId')
            }
        } catch (e) {
            console.error(e);
        }
    };

    const handlePropertySelect = async (rowIndex, propertyId) => {
        updateUser(rowIndex, propertyId);

        if (!propertyId) {
            setCustomFieldOptionsByRow(prev => {
                const copy = { ...prev };
                delete copy[rowIndex];
                return copy;
            });
            setSelectedCustomFieldByRow(prev => {
                const copy = { ...prev };
                delete copy[rowIndex];
                return copy;
            });
            setCustomFieldErrorByRow(prev => {
                const copy = { ...prev };
                delete copy[rowIndex];
                return copy;
            });
            return;
        }

        setCustomFieldLoadingByRow(prev => ({ ...prev, [rowIndex]: true }));
        setCustomFieldErrorByRow(prev => ({ ...prev, [rowIndex]: null }));

        try {
            const response = await services.customfield.GET_CUSTOM_FIELD_BY_TASK_ID(propertyId);

            const options = (response?.data?.data || []).map(item => {
                const cf = item?.customField ?? {};
                const valueField = cf?.value;

                const getLabel = (v) =>
                    typeof v === "object" && v !== null
                        ? v.label ?? v.name ?? v.value ?? ""
                        : (v ?? "");

                const label = Array.isArray(valueField)
                    ? valueField.map(getLabel).join(", ")
                    : getLabel(valueField);

                return {
                    label: label || cf.name || "Unnamed",
                    value: cf.id ?? item?.id ?? "",
                    _rawCustomField: cf,
                    _rawItem: item
                };
            });

            setCustomFieldOptionsByRow(prev => ({ ...prev, [rowIndex]: options }));

            // ❌ previously ""
            setSelectedCustomFieldByRow(prev => ({
                ...prev,
                [rowIndex]: prev[rowIndex] ?? []
            }));


        } catch (err) {
            console.error('Failed to fetch custom fields for property', err);
            setCustomFieldOptionsByRow(prev => ({ ...prev, [rowIndex]: [] }));
            setCustomFieldErrorByRow(prev => ({ ...prev, [rowIndex]: 'Failed to load fields' }));
        } finally {
            setCustomFieldLoadingByRow(prev => ({ ...prev, [rowIndex]: false }));
        }
    };


    useEffect(() => {
        const getProperties = async () => {
            if (!board) {
                setCustomPropertyOptions([]);
                return;
            }

            try {
                const response = await services.property.GET_PROPERTY_BY_BOARD_ID(board);
                const options = (response?.data?.data || []).map((prop) => ({
                    label: prop.property.propertyName,
                    value: prop.id,
                }));

                setCustomPropertyOptions(options);
            } catch (error) {
                console.error(error);
                setCustomPropertyOptions([]);
            }
        };

        getProperties();
    }, [board]);

    const updateConditionField = (index, value) => {
        setConditions((prev) =>
            prev.map((cond, i) => {
                if (i === index) {
                    const newCond = { ...cond, field: value, value: '' };

                    if (value === 'assignee') {
                        newCond.operator = 'equals';
                    } else if (value === 'customerWaiting' || value === 'customerNotResponding') {
                        newCond.operator = 'moreThanMins';
                    }
                    return newCond;
                }
                return cond;
            }),
        );
    };

    const updateConditionOperator = (index, value) => {
        setConditions((prev) =>
            prev.map((cond, i) => (i === index ? { ...cond, operator: value, value: '' } : cond)),
        );
    };

    const updateConditionValue = (index, value) => {
        setConditions((prev) => {
            const updated = prev.map((cond, i) => {
                if (i === index) {
                    const newCond = { ...cond, value };
                    return newCond;
                }
                return cond;
            });
            return updated;
        });
    };
    const selectedActionTypes = actionRows.map((row) => row.action).filter(Boolean);

    const selectedFirstAction = Array.isArray(actionRows) && actionRows[0]?.action ? actionRows[0].action : null;
    const lastTwoSelected = selectedActionTypes.slice(-2);

      const handleUpdateCell = async (propertyId, newValue, color, idx, flag) => {
        try {
            const response = await services.property.GET_PROPERTY_BY_ID(propertyId);
            const propertyName = response?.data?.data?.property?.name;

            const payload = {
                customPropertyId: propertyId,
                customField: {
                    value: newValue,
                    name: propertyName,
                    color: color,
                },
            };

            const createTag = await services.customfield.CREATE_CUSTOM_FIELD(payload);

            const newField = createTag?.data?.data;
            if (!newField) return;

            const newOption = {
                id: newField.id,
                value: newField.id,
                label: newValue,
                color: color,
                _rawItem: {
                    id: newField.id,
                    customField: {
                        value: newValue,
                        color: color,
                    },
                },
            };

            // ✅ Update dropdown options
            setCustomFieldOptionsByRow(prev => ({
                ...prev,
                [idx]: [...(prev[idx] || []), newOption],
            }));

            // ✅ Update selected values
            setSelectedCustomFieldByRow(prev => ({
                ...prev,
                [idx]: [
                    ...(prev[idx] || []),
                    {
                        id: newField.id,
                        label: newValue,
                        color: color,
                    },
                ],
            }));

            fetchProperty(propertyId);
        } catch (error) {
            console.error('Failed to create custom field', error);
        }
    };

    useEffect(() => {

        if (editPropertyId != null && editId != null) {
            fetchProperty(editPropertyId);
        }
    }, [editId, editPropertyId]);
    const fetchProperty = async (editPropertyId) => {
        try {
            const response = await services.property.GET_PROPERTY_BY_ID(editPropertyId);
            const propertyData = response?.data?.data;
            await handlePropertySelect(propertyData?.index ?? 0, propertyData?.id);

        } catch (error) {
            console.error('Error fetching property:', error);
        }
    };
    const handleUpdatedCustomField = async (propertyId, newValue, color, field, idx) => {
        try {
            const response = await services.property.GET_PROPERTY_BY_ID(propertyId);
            const propertyName = response?.data?.data?.property?.name;

            // 👇 Convert to correct array structure
            const customFieldArray = selectedCustomFieldByRow[idx] || [];
            const data = {
                customPropertyId: propertyId,
                customField: {
                    value: newValue,
                    name: propertyName,
                    color: color,
                },
            };


            const responsedata = await services.customfield.UPDATE_CUSTOM_FIELD(customeFiedId, data);

            if (responsedata?.status === 200) {
                setSelectedCustomFieldByRow(prev => ({
                    ...prev,
                    [idx]: data
                }));
                await handlePropertySelect(idx, propertyId);
            }

            setCustomeFieldId(null);
        } catch (error) {
            console.error('Failed to update custom field', error);
        }
    };


    const availableActions = [
        { label: 'assign it to', value: 'assignTo' },
        { label: 'assign with round robin to', value: 'assignToRoundRobin' },
        { label: 'unassign it', value: 'unassign' },
        { label: 'mark it complete', value: 'markComplete' },
        { label: 'mark it incomplete', value: 'markIncomplete' },
        { label: 'Labels', value: 'setEmailLabel' },
        { label: 'Set custom property', value: 'setCustomProperty' },
    ];
    const updateAction = (index, value) => {
        const updated = [...actionRows];


        if (boardName.some((b) => b.value === value)) {
            updated[index].boardId = value;
        } else {
            updated[index].action = value;
            updated[index].user = '';
            updated[index].boardId = '';
            updated[index].entityId = '';


            if (value === 'sendOverdueAlert') {
                updated[index].message = '🔥Overdue - Customer is waiting for a reply.';
            } else if (value === 'sendUpcomingAlert') {
                updated[index].message = "⚡Upcoming soon - Don't forget";
            } else if (value === 'sendNotificationTo') {
                updated[index].message = 'Issue escalated to you';
            }
        }


        setActionRows(updated);
    };

    const removeCondition = (index) => {
        const updated = conditions.filter((_, i) => i !== index);
        setConditions(updated);
    };
    const getAllBoardDateTable = async () => {
        try {
            const response = await services.board.GET_BOARD_LIST();

            if (response) {
                setBoardList(response?.data?.data);


                const boardNameOptions =
                    response?.data?.data?.map((board) => ({
                        label: board.boardName,
                        value: board.id,
                    })) || [];
                setBoardName(boardNameOptions);
            }
        } catch (error) {
            console.error('Error fetching board date table:', error);
        }
    };
    const buildPayload = () => {
        if (!advancedMode) {
            return {
                type: "new",
                isColumnAutomation: true,
                when: {
                    gmailUserId: selectedMailUser ? selectedMailUser.value : "",
                },
                condition: runOnExisting
                    ? [
                        {
                            operator: "lte",
                            operand: "existingInboxMails",
                            value: days,
                        }
                    ]
                    : [],
                action: [
                    {
                        order: 0,
                        action: "createOnList",
                        boardId: board,
                        entityId: list
                    },
                    {
                        action: "subEmailInbox",
                        isProcessed: skipReplies
                    },
                    {
                        action: "emailInbox",
                        hasReply: skipInbox
                    }
                ]
            };
        }

        const staticCondition = {
            field: 'board',
            operator: 'equals',
            value: board,
        };

        if (runOnExisting) {
            const existing = conditions.find(
                (c) => c.field === "existingInboxMails"
            );

            if (existing) {
                existing.value = days;
            } else {
                conditions.push({
                    field: "existingInboxMails",
                    operator: "lte",
                    value: days,
                });
            }

        } else {
            const index = conditions.findIndex(
                (c) => c.field === "existingInboxMails"
            );

            if (index !== -1) {
                conditions.splice(index, 1);
            }
        }

        let allConditions = conditions;

        return {
            type: selectedType,
            isColumnAutomation: true,
            when: {
                gmailUserId: selectedMailUser ? selectedMailUser?.value : '',
            },
            condition: allConditions.map((c) => ({
                operand: c.field,
                operator: c.operator,
                value: c.field === 'assignee'
                    ? [{ entityId: c.value }]
                    : c.value,
            })),
            action: (() => {
                const baseActions = actionRows.map((a, index) => {
                    let actionName = a.action;

                    if (a.action === 'moveToNext') {
                        actionName = 'moveToNextList';
                    } else if (a.action === 'moveToPreviousList') {
                        actionName = 'moveToPreviousList';
                    }

                    const payload = {
                        action: actionName,
                        order: index,
                    };

                    if (a.action === 'createOnList') {
                        return {
                            ...payload,
                            boardId: a.boardId,
                            entityId: a.entityId,
                        };
                    }

                    if (['assignTo', 'unassign'].includes(a.action)) {
                        return {
                            ...payload,
                            entityId: a.user,
                        };
                    }

                    if (a.action === 'assignToRoundRobin') {
                        return {
                            ...payload,
                            entityIds:
                                a.users?.map((u) => ({
                                    entityId: u.value,
                                    name: u.label,
                                })) || [],
                        };
                    }

                    if (a.action === 'setEmailLabel') {
                        return {
                            ...payload,
                            action: 'setEmailLabel',
                            labelName: a.user
                                ? a.user.name || a.user.label
                                : '',
                            ...(a.user?.parentId
                                ? { parentId: a.user.parentId }
                                : {}),
                        };
                    }

               if (a.action === 'setCustomProperty') {
                        const customPropertyId = a.user || a.customPropertyId || a.propertyId || '';
                    
                        // Always take the correct array from selectedCustomFieldByRow
                        let customFieldArray = [];
                    
                        if (selectedCustomFieldByRow?.[index]) {
                            // Already correct format: [{id:"..."}, {id:"..."}]
                            customFieldArray = selectedCustomFieldByRow[index];
                        }
                    
                        // Fallback for edit mode (single ID)
                        else if (a.customFieldId || a.entityId || a.selectedCustomFieldId) {
                            customFieldArray = [
                                { id: String(a.customFieldId || a.entityId || a.selectedCustomFieldId) }
                            ];
                        }
                    
                        return {
                            ...payload,
                            action: "setCustomProperty",
                            customProperty: customPropertyId,
                            customField: customFieldArray, // <-- Correct final output
                        };
                    }
                    

                    if (a.action === 'setSlaAlertTag') {
                        return {
                            ...payload,
                            entityValue: a.entityId || [],
                        };
                    }

                    if (
                        a.action === 'sendOverdueAlert' ||
                        a.action === 'sendUpcomingAlert' ||
                        a.action === 'sendNotificationTo'
                    ) {
                        return {
                            ...payload,
                            entityId: a.entityId,
                            entityValue: a.message || '',
                        };
                    }

                    return payload;
                });

                if (selectedType === 'new') {
                    baseActions.push({
                        action: 'subEmailInbox',
                        isProcessed: skipReplies,
                    });
                    baseActions.push({
                        action: 'emailInbox',
                        hasReply: skipInbox,
                    });
                }

                return baseActions;
            })(),
        };
    };

    const addActionRow = () => {
        setActionRows([...actionRows, { action: '', user: '', boardId: '', entityId: '' }]);
    };
    const shouldHideAddButton =
        ['markComplete', 'markIncomplete'].includes(actionRows[1]?.action) || actionRows.length >= 3;

    const showUserSelectFor = ['assignTo', 'assignToRoundRobin', 'setEmailLabel', 'setCustomProperty'];
      const updateUser = (index, value, isMulti = false) => {
        setActionRows(prev => {
            const updated = [...prev];
            if (!updated[index]) updated[index] = {};
    
            const action = updated[index].action;
    
            if (action === "assignTo") {
                updated[index].user = value;
            } 
            else if (action === "assignToRoundRobin") {
                updated[index].users = value;  
            } 
            else if (action === "setCustomProperty") {
                updated[index].propertyId = value;
            }
    
            return updated;
        });
    };

    const updateBoardList = (index, value) => {
        const updated = [...actionRows];
        updated[index].entityId = value;
        setActionRows(updated);
    };

    const handleGetSyncGmail = async () => {
        try {
            const response = await services.email.Get_The_Linked_Email();
            const formattedOptions = response?.data?.map((item) => ({
                value: item.id,
                label: item.email,
            }));

            setSyncGmail(formattedOptions);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        handleGetSyncGmail();
        getAllBoardDateTable();
        GET_ALL_USER_DATA()
        LablesName();
    }, []);
    const getSELECTED_BOARD = async (boardSelect) => {
        try {
            const { data } = await services.board.SELECTED_BOARD(boardSelect);

            setColumnList(data);
        } catch (error) {
            console.error(error);
        }
    };


    const selectedIsFields = Array.isArray(conditions)
        ? conditions
            .filter((c, i) => c.operator === 'equals')
            .map((c) => c.field)
            .filter(Boolean)
        : [];

    useEffect(() => {
        if (syncGmail.length > 0) {

            const storedGmailUserId = getLocalStorageItem('editGmailUserId')
            if (storedGmailUserId) {
                const gmailUser = syncGmail.find((user) => user.value === storedGmailUserId);
                if (gmailUser) {
                    setSelectedMailUser(gmailUser);
                }
            }
        }
    }, [syncGmail]);

    const syncBasicToAdvanced = (automation) => {
        /* ---------------- CONDITIONS ---------------- */
        setConditions((prev) => {
            // Edit mode → keep existing
            if (prev && prev.length > 0) return prev;

            // New mode → default
            return [
                {
                    field: "sender",
                    operator: "equals",
                    value: "",
                },
            ];
        });

        /* ---------------- ACTIONS ---------------- */
        setActionRows((prev) => {
            let actions = [...(prev || [])];

            // 1️⃣ Ensure createOnList exists
            const hasCreate = actions.some(
                (a) => a.action === "createOnList"
            );

            if (!hasCreate && board && list) {
                actions.unshift({
                    action: "createOnList",
                    boardId: board,
                    entityId: list,
                });
            }

            // 2️⃣ Remove empty actions
            actions = actions.filter((a) => a.action);

            // 3️⃣ Fix order
            return actions.map((a, i) => ({
                ...a,
                order: i,
            }));
        });
    };

    function flattenLabels(labels, parentPath = [], parentId = null) {
        let options = [];
        labels.forEach(label => {
            const currentPath = [...parentPath, label.name];
            options.push({
                label: currentPath.join('/'),
                value: JSON.stringify({
                    parentId: parentId,
                    childId: label.id,
                    name: label.name,
                }),
            });
            if (label.children && label.children.length) {
                options = options.concat(flattenLabels(label.children, currentPath, label.id));
            }
        });
        return options;
    }
    const getDefaultColorByValue = (value) => {
        return defaultColorMap[value] || defaultColorMap.default;
    };
    const allOptions = useMemo(() => flattenLabels(lables), [lables]);

    const handleLabelChange = (i, value) => {
        if (!value) return updateUser(i, null);

        const selected = JSON.parse(value);
        updateUser(i, {
            id: selected.childId,
            name: selected.name,
            parentId: selected.parentId || undefined,
        });
    };

    const filteredOptions = useMemo(() => {
        return allOptions;
    }, [allOptions]);
    const validateBasicMode = () => {
        const errors = {};

        if (!selectedMailUser) {
            errors.selectedMailUser = "Email address is required";
        }

        if (!board) {
            errors.board = "Board is required";
        }

        if (!list) {
            errors.list = "List is required";
        }

        setBasicErrors(errors);

        return Object.keys(errors).length === 0;
    };


    return (
        <Modal
            show={show}
            onHide={() => { getAllAutomation(), setAdvancedMode(false), setStep(1), setAutomations(false) }}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ scrollbarWidth: 'none' }}
        >
            <Modal.Header closeButton>
                <h2 className="text-[28px] pt-[1vw] px-[1.4vw] font-normal font-google">Add incoming emails to a board</h2>
            </Modal.Header>
            <Modal.Body className="border-t border-gray-200">
                {!advancedMode ? (
                    <div className="flex flex-col  h-[470px] overflow-y-auto" style={{ scrollbarWidth: 'none' }}>
                        <div className="bg-white rounded-lg    w-full ">
                            <div className="bg-white rounded-lg p-3 space-y-8">

                                <div className="border-b border-gray-200 pb-8">
                                    <h2 className="text-base font-semibold text-gray-900 mb-4">Step 1: What's the email address?</h2>
                                    <Select
                                        options={syncGmail}
                                        className="w-full border border-gray-300 rounded-md text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                        value={selectedMailUser}
                                        onChange={(selectedOption) => { setSelectedMailUser(selectedOption); }}
                                    />
                                </div>

                                {/* Step 2 */}
                                {/* <div className="border-b border-gray-200 pb-8">
                                    <h2 className="text-base font-semibold text-gray-900 mb-4">Step 2: How do you get email on this address?</h2>
                                    <div className="space-y-3">
                                        <label className="flex items-center cursor-pointer">
                                            <input
                                                type="radio"
                                                name="access-method"
                                                value="mailbox"
                                                checked={accessMethod === "mailbox"}
                                                onChange={(e) => setAccessMethod(e.target.value)}
                                                className="w-4 h-4 text-gray-600 cursor-pointer"
                                            />
                                            <span className="ml-3 text-gray-700">
                                                I log into the Mailbox (select this option if you use an alias as well)
                                            </span>
                                        </label>
                                        <label className="flex items-center cursor-pointer">
                                            <input
                                                type="radio"
                                                name="access-method"
                                                value="google-group"
                                                checked={accessMethod === "google-group"}
                                                onChange={(e) => setAccessMethod(e.target.value)}
                                                className="w-4 h-4 text-gray-600 cursor-pointer"
                                            />
                                            <span className="ml-3 text-gray-700">Mail is forwarded to my Inbox via a Google Group</span>
                                        </label>
                                    </div>
                                </div> */}

                                {/* Step 3 */}
                                <div className="border-b border-gray-200 pb-8">
                                    <h2 className="text-base font-semibold text-gray-900 mb-4">
                                        Step 2: Where do you want to route email sent to this address to?
                                    </h2>
                                    <div className="space-y-3">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-900 mb-2">Board:</label>
                                            <div className="relative">
                                                <select
                                                    value={board}
                                                    onChange={(e) => { setBoard(e.target.value), getSELECTED_BOARD(e.target.value) , setBasicErrors((prev) => ({ ...prev, board: null })); }}
                                                    className="w-full px-4 py-2 border border-gray-300 rogetSELECTED_BOARDunded-md text-gray-900 bg-white appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                >
                                                    <option value="" disabled>
                                                        Choose a board...
                                                    </option>
                                                    {boardName?.map((item) => (
                                                        <option key={item.value} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    ))}
                                                </select>
                                                <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-600 pointer-events-none" />
                                            </div>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-900 mb-2">List:</label>
                                            <div className="relative">
                                                <select
                                                    value={list}
                                                    onChange={(e) =>{ setList(e.target.value), setBasicErrors((prev) => ({ ...prev, list: null }))}}
                                                    className="w-full px-4 py-2 border border-gray-300 rounded-md text-gray-900 bg-white appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                >
                                                    <option value="" disabled>
                                                        Choose a list...
                                                    </option>
                                                    {columnList &&
                                                        columnList.map((item, idx) => (
                                                            <option key={idx} value={item.id}>
                                                                {item.coloum}
                                                            </option>
                                                        ))}
                                                </select>
                                                <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-600 pointer-events-none" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Step 4 */}
                                <div className="pb-8">
                                    <h2 className="text-base font-semibold text-gray-900 mb-4">
                                        Step 3 : How do you want your Gmail Inbox to work?
                                    </h2>
                                    <div className="space-y-3">
                                        <label className="flex items-center cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={!skipInbox}
                                                onChange={(e) => setSkipInbox(!e.target.checked)}
                                                className="w-4 h-4 rounded border-gray-300 text-gray-600 cursor-pointer"
                                            />
                                            <span className="ml-3 text-gray-700">New emails should skip the inbox</span>
                                        </label>
                                        <label className="flex items-center cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={skipReplies}
                                                onChange={(e) => setSkipReplies(e.target.checked)}
                                                className="w-4 h-4 rounded border-gray-300 text-gray-600 cursor-pointer"
                                            />
                                            <span className="ml-3 text-gray-700">
                                                Replies to existing conversations already on the board should skip the inbox
                                            </span>
                                        </label>
                                        <label className="flex items-center cursor-pointer gap-2">
                                            <input
                                                type="checkbox"
                                                checked={runOnExisting}
                                                onChange={(e) => setRunOnExisting(e.target.checked)}
                                                className="w-4 h-4 rounded border-gray-300 text-gray-600 cursor-pointer"
                                            />
                                            <span className="text-gray-700">Run this automation on existing emails in the Inbox, going back</span>
                                            <select value={days} onChange={(e) => setDays(e.target.value)}>
                                                {Array.from({ length: 10 }, (_, i) => i + 1).map((day) => (
                                                    <option key={day} value={day}>
                                                        {day} day{day > 1 ? "s" : ""}
                                                    </option>
                                                ))}
                                            </select>
                                        </label>
                                    </div>
                                </div>

                                {/* Advanced Mode Link */}
                                <div className="pt-4">
                                    <a href="#" className="text-blue-500 font-medium hover:text-blue-600" onClick={() => { if (!advancedMode) syncBasicToAdvanced(), setAdvancedMode(!advancedMode) }}>
                                        Switch to Advanced mode
                                    </a>
                                    <span className="text-gray-600 ml-2">for more options</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="bg-white rounded-lg p-3 space-y-6 ">
                            <div className="pb-6 border-b border-gray-200">
                                <div className="flex gap-3 items-end">
                                    <label className="block text-sm font-medium text-gray-700 mb-3 w-[60px]">When</label>
                                    <div className="flex-1">
                                        <select className=" px-4 py-2 border border-gray-300 rounded-md text-gray-900 bg-white appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500  w-[270px]">
                                            <option>a new email is received</option>
                                        </select>
                                    </div>
                                    <input
                                        type="text"
                                        className="border border-gray-300 rounded px-3 py-2 w-[200px] bg-white"
                                        value="in the mailbox"
                                        readOnly
                                    />
                                    <Select
                                        options={syncGmail}
                                        className="border border-gray-300 rounded  w-[450px]"
                                        value={selectedMailUser}
                                        onChange={(selectedOption) => { setSelectedMailUser(selectedOption); }}
                                    />
                                </div>
                            </div>

                            <>
                                {Array.isArray(conditions) &&
                                    conditions.map((cond, index) => (
                                        <div key={index} className="flex items-center gap-3 mb-1">
                                            <span className="font-medium text-gray-700 w-[60px]">
                                                {index === 0 ? 'if' : 'and'}
                                            </span>

                                            <select
                                                className="border border-gray-300 rounded px-3 py-2 w-[270px] bg-white"
                                                value={cond.field}
                                                onChange={(e) => updateConditionField(index, e.target.value)}
                                            >
                                                <option value="" disabled>
                                                    Select a condition...
                                                </option>
                                                {conditionOptions
                                                    .filter(
                                                        (opt) =>
                                                            !selectedIsFields.includes(opt.value) ||
                                                            cond.field === opt.value,
                                                    )
                                                    .map((opt, i) => (
                                                        <option key={i} value={opt.value}>
                                                            {opt.label}
                                                        </option>
                                                    ))}
                                            </select>

                                            <select
                                                className="border border-gray-300 rounded px-3 py-2 w-[200px] bg-white"
                                                value={cond.operator}
                                                onChange={(e) => updateConditionOperator(index, e.target.value)}
                                            >
                                                {operatorOptions.map((op, i) => (
                                                    <option key={i} value={op.value}>
                                                        {op.label}
                                                    </option>
                                                ))}
                                            </select>

                                            <input
                                                type="text"
                                                className="border border-gray-300 rounded px-3 py-2 w-[450px] bg-white"
                                                value={cond.value}
                                                onChange={(e) => updateConditionValue(index, e.target.value)}
                                            />

                                            {conditions.length > 1 && (
                                                <button
                                                    onClick={() => removeCondition(index)}
                                                    className="text-red-500 fonst-bold text-xl"
                                                >
                                                    ×
                                                </button>
                                            )}
                                        </div>
                                    ))}

                                <div>
                                    <a
                                        onClick={addCondition}
                                        className="text-blue-500 font-bold px-4 py-2 text-decoration-none "
                                    >
                                        + Add condition
                                    </a>
                                </div>
                                <div>
                                    {actionRows.map((row, i) => (
                                        <div key={i} className="flex items-center gap-3 mb-2 mt-4">
                                            <span className="font-medium text-gray-700 w-[60px]">
                                                {i == 0 ? 'then' : ' and'}
                                            </span>

                                            {i == 0 ? (
                                                <>
                                                    <div className="flex items-start gap-4 ">
                                                        <div className="flex flex-col w-[270px]">
                                                            <select
                                                                className="border border-gray-300 rounded px-3 py-2 w-full bg-white"
                                                                disabled
                                                            >
                                                                <option>move it to the board</option>
                                                            </select>
                                                            <div className="h-5" aria-hidden="true" />
                                                        </div>

                                                        <div className="flex flex-col w-[200px]">
                                                            <select
                                                                className={`border rounded px-3 py-2 w-full bg-white ${boardError ? 'border-red-500' : 'border-gray-300'}`}
                                                                value={row.boardId || ''}
                                                                onChange={(e) => {
                                                                    updateAction(i, e.target.value);
                                                                    setBoard(e.target.value);
                                                                    getSELECTED_BOARD(e.target.value)
                                                                }}
                                                            >
                                                                <option value="" disabled>
                                                                    Choose a board...
                                                                </option>
                                                                {boardName?.map((item) => (
                                                                    <option key={item.value} value={item.value}>
                                                                        {item.label}
                                                                    </option>
                                                                ))}
                                                            </select>

                                                            <div className="h-5">
                                                                {boardError && (
                                                                    <p className="text-red-500 text-sm mt-1">
                                                                        {boardError}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="flex flex-col w-[450px]">
                                                            <select
                                                                className="border border-gray-300 rounded px-3 py-2 w-full bg-white"
                                                                value={row.entityId || ''}
                                                                onChange={(e) => updateBoardList(i, e.target.value)}
                                                            >
                                                                <option value="" disabled>
                                                                    Choose a list...
                                                                </option>
                                                                {columnList &&
                                                                    columnList.map((item, idx) => (
                                                                        <option key={idx} value={item.id}>
                                                                            {item.coloum}
                                                                        </option>
                                                                    ))}
                                                            </select>
                                                            <div className="h-5" aria-hidden="true" />
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                <select
                                                    className="border border-gray-300 rounded  w-[450px] px-3 py-2 bg-white mt-3"
                                                    value={row.action}
                                                    onChange={(e) => updateAction(i, e.target.value)}
                                                >
                                                    <option value="">Select Action</option>

                                                    {(i === 1
                                                        ? availableActions.filter((item) => {
                                                            if (!selectedFirstAction) return true;

                                                            const firstGroup = [
                                                                'assignTo',
                                                                'assignToRoundRobin',
                                                                'unassign',
                                                            ];
                                                            const secondGroup = ['markComplete'];


                                                            if (firstGroup.includes(selectedFirstAction)) {
                                                                return item.value !== selectedFirstAction;
                                                            }

                                                            if (secondGroup.includes(selectedFirstAction)) {
                                                                return !secondGroup.includes(item.value);
                                                            }

                                                            return true;
                                                        })
                                                        : availableActions
                                                    )

                                                        .filter((action) => {
                                                            return (
                                                                !lastTwoSelected.includes(action.value) ||
                                                                row.action === action.value
                                                            );
                                                        })
                                                        .map((item, idx) => (
                                                            <option key={idx} value={item.value}>
                                                                {item.label}
                                                            </option>
                                                        ))}
                                                </select>
                                            )}




                                            {showUserSelectFor.includes(row.action) &&
                                                (row.action === 'assignToRoundRobin' ? (
                                                    <Select
                                                        isMulti
                                                        options={options}
                                                        className="border border-gray-300  rounded w-[500px] py-[1px] mt-3"
                                                        placeholder="Select users"
                                                        value={row.users || []}
                                                        onChange={(selected) => updateUser(i, selected, true)}
                                                    />
                                                ) : row.action === "assignTo" ? (
                                                    <select
                                                        className="border border-gray-300 w-[500px] rounded px-3 py-2 bg-white mt-3"
                                                        value={row.user}
                                                        onChange={(e) => updateUser(i, e.target.value)}
                                                    >
                                                        <option value="">Select user</option>
                                                        {options.map((user, j) => (
                                                            <option key={j} value={user.value}>
                                                                {user.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                )
                                                    : row.action === "setEmailLabel" ? (


                                                        <>

                                                            <FormControl fullWidth size="small" className="mt-3" >
                                                                <InputLabel id={`select-label-${i}`}>Select label</InputLabel>
                                                                <MuiSelect
                                                                    labelId={`select-label-${i}`}
                                                                    value={
                                                                        row.user && row.user.name
                                                                            ? JSON.stringify({
                                                                                parentId: row.user.parentId || null,
                                                                                childId: row.user.id || null,
                                                                                name: row.user.name,
                                                                            })
                                                                            : ''
                                                                    }
                                                                    label="Select label"
                                                                    onChange={(e) => handleLabelChange(i, e.target.value)}
                                                                >
                                                                    <MenuItem value="">
                                                                        <em>Select label</em>
                                                                    </MenuItem>
                                                                    {filteredOptions.map(({ label, value }) => (
                                                                        <MenuItem key={value} value={value}>
                                                                            {label}
                                                                        </MenuItem>
                                                                    ))}
                                                                </MuiSelect>
                                                            </FormControl>
                                                        </>

                                                    ) : row.action === 'setCustomProperty' ? (
                                                        <>
                                                            <select
                                                                className="border border-gray-300 w-[500px] rounded px-3 py-2 bg-white mt-3"
                                                                value={row.propertyId || row.customProperty}
                                                                onChange={(e) => handlePropertySelect(i, e.target.value)}
                                                            >
                                                                <option value="">Select property</option>
                                                                {customPropertyOptions.map((prop, j) => (
                                                                    <option key={j} value={prop.value}>
                                                                        {prop.label}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            <div className="mt-3 w-50">
                                                                {customFieldLoadingByRow[i] ? (
                                                                    <p className="text-sm text-gray-500">Loading fields...</p>
                                                                ) : customFieldErrorByRow[i] ? (
                                                                    <p className="text-sm text-red-500">{customFieldErrorByRow[i]}</p>
                                                                ) : Array.isArray(customFieldOptionsByRow[i]) && customFieldOptionsByRow[i].length > 0 ? (

                                                                    <>
                                                                        <AutomationStatusDropdown idx={i} setSelectedCustomFieldByRow={setSelectedCustomFieldByRow} customFieldOptionsByRow={customFieldOptionsByRow} selectedCustomFieldByRow={selectedCustomFieldByRow} getDefaultColorByValue={getDefaultColorByValue} customeFiedId={customeFiedId}
                                                                                                                                                       setCustomeFieldId={setCustomeFieldId} handleUpdateCell={handleUpdateCell} propertyId={row?.propertyId || row.customProperty} handleUpdatedCustomField={
                                                                                                                                                           handleUpdatedCustomField
                                                                                                                                                       } deleteCustomField={deleteCustomField} setCustomFieldOptionsByRow={setCustomFieldOptionsByRow } />
                                                                       
                                                                    </>
                                                                ) : null}
                                                            </div>
                                                        </>
                                                    ) : null



                                                )}




                                            {i > 0 && (
                                                <button
                                                    onClick={() => {
                                                        const updated = [...actionRows];
                                                        updated.splice(i, 1);
                                                        setActionRows(updated);
                                                    }}
                                                    className="text-red-500 fonst-bold text-xl px-2"
                                                    title="Remove action"
                                                    type="button"
                                                >
                                                    ×
                                                </button>
                                            )}
                                        </div>
                                    ))}

                                    {!shouldHideAddButton && (
                                        <a
                                            onClick={addActionRow}
                                            className="text-blue-500 font-bold px-4 py-2  text-decoration-none"
                                            style={{ minWidth: '120px' }}
                                            type="button"
                                        >
                                            + Add action
                                        </a>
                                    )}
                                </div>
                            </>

                            {duplicateMsg && (
                                <div className="flex items-center gap-3 mt-2">
                                    <span className="font-medium text-gray-700 w-[60px]"></span>
                                    <div className="text-red-500 text-sm bg-red-50 border border-red-200 rounded px-3 py-2 w-90">
                                        ⚠️ {duplicateMsg}
                                    </div>
                                </div>
                            )}


                            <div className="mt-6 border-t pt-4">
                                <div className="font-bold text-lg mb-2">Advanced options</div>
                                <div className="flex flex-col gap-3">
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="checkbox"
                                            checked={!skipInbox}
                                            onChange={(e) => setSkipInbox(!e.target.checked)}
                                        />
                                        New emails should skip the inbox
                                    </label>
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="checkbox"
                                            checked={skipReplies}
                                            onChange={(e) => setSkipReplies(e.target.checked)}
                                        />
                                        Replies to existing conversations already on the board should skip the inbox
                                    </label>
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="checkbox"
                                            checked={runOnExisting}
                                            onChange={(e) => setRunOnExisting(e.target.checked)}
                                        />

                                        Run this automation on existing emails in the Inbox, going back

                                        <select value={days} onChange={(e) => setDays(e.target.value)}>
                                            {Array.from({ length: 10 }, (_, i) => i + 1).map((day) => (
                                                <option key={day} value={day}>
                                                    {day} day{day > 1 ? "s" : ""}
                                                </option>
                                            ))}
                                        </select>
                                    </label>


                                </div>
                            </div>

                            <div className="pt-4">
                                <button onClick={() => setAdvancedMode(false)} className="text-blue-500 font-medium hover:text-blue-600">
                                    ← Back to Basic mode
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <div className="flex justify-end w-full">
                    <button
                        onClick={() => { setAdvancedMode(false), setStep(1), setAutomations(false) }}
                        className=" text-gray-800 border font-google border-solid border-[#bdbdbd]  font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mr-2"
                    >
                        Cancel
                    </button>
                    <button
                        className='font-google text-white font-bold py-2 px-4 font-normal rounded focus:outline-none focus:shadow-outline bg-blue-500 hover:bg-blue-700 cursor-pointer'
                        onClick={() => {
                            // if (!advancedMode) {
                            //     const isValid = validateBasicMode();
                            //     if (!isValid) return; 
                            // }

                            handleCreate(); 
                        }}
                    >
                        {editId ? 'Update' : 'Create'}
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default IncomingMail